import type {DataRouterBlobPayload} from '@github-ui/code-view-types'
import type {DataRouterApplicationBuilder} from '@github-ui/react-core/future/data-router-application'
import {mainQuery} from '@github-ui/react-core/future/main-query'

import {codeViewAppBuilder} from '../config/app-builder'
import {fileTreeQuery} from '../queries/file-tree-query'

export function buildCodeViewBlobRoute(appBuilder: DataRouterApplicationBuilder<string>) {
  return appBuilder.createQueryRouteConfig('codeViewBlobRoute', {
    path: '/:owner/:repo/blob/:branch/*',
    queries: [
      mainQuery<DataRouterBlobPayload>({
        queryDeps: ({pathname, searchParams}) => ({pathname, searchParams: Object.fromEntries(searchParams)}),
        encodeFetchPath: true,
      }),
      fileTreeQuery,
    ],
    uiServiceOptions: {
      tsrConfig: {
        validateSearch: (search: Record<string, unknown>): {plain?: string; short_path?: string; h?: string} =>
          search as {plain?: string; short_path?: string; h?: string},
      },
    },
  })
}

export const codeViewBlobRoute = buildCodeViewBlobRoute(codeViewAppBuilder)
